<template>
  <div v-if="item">

    <h5>Внимание! Если вы сохраните пароль, пользователь получит  смс с паролем</h5>
    <br/>
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
          <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>Сохранить и отправить СМС
          </button>
    </div>
  </div>
</template>
<script>

import { cardUpdate } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "dealers",
    cardSetLink: "dealers",
    item: null,
    fields: [
             {
                    col:'col-12 col-md-6',
                    key: "password",
                    label: "Новый пароль (минимум 5 символов)",
                    type: "field",
                    textType: "text",
              },
      ],
  }),
  props: ["id"],
  async created() {
    if (this.id) {
        this.item = {
          id: this.id,
          password: ''
        };
    }
  },
  methods: {
    cardUpdate: cardUpdate,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      this.item['password'] = '';
    },
  },
};
</script>
<style>
</style>
